import { podcastData } from '../data/podcastData.js';

export class Podcast {
    constructor(containerId, options = {}) {
        this.containerId = containerId;
        this.element = null;
        this.onPodcastClick = options.onPodcastClick || ((id) => console.log(`Podcast card ${id} clicked`));
    }

    init() {
        this.element = document.getElementById(this.containerId);
        if (!this.element) {
            console.error(`Podcast container #${this.containerId} not found.`);
            return;
        }

        this.injectStyles();
        this.render();
        this.attachEventListeners();
    }

    injectStyles() {
        const styleId = 'podcast-grid-styles';
        if (document.getElementById(styleId)) return;

        const css = `
            .podcast-container {
                max-width: 1200px;
                margin: 0 auto;
                padding: 2rem;
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            }
            .podcast-container h1 {
                text-align: center;
                font-size: 2.5rem;
                margin-bottom: 2rem;
                color: #1a1a1a;
            }
            .podcast-grid {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                gap: 2rem;
            }
            .podcast-card {
                position: relative;
                background: #fff;
                border-radius: 12px;
                box-shadow: 0 4px 12px rgba(0,0,0,0.08);
                overflow: hidden;
                transition: transform 0.3s ease, box-shadow 0.3s ease;
                display: flex;
                flex-direction: column;
            }
            .podcast-card:hover {
                transform: translateY(-8px);
                box-shadow: 0 12px 24px rgba(0,0,0,0.12);
            }
            .podcast-card-image {
                width: 100%;
                aspect-ratio: 16 / 9;
                object-fit: cover;
                display: block;
            }
            .podcast-card-content {
                padding: 1.5rem;
                flex-grow: 1;
            }
            .podcast-card-title {
                font-size: 1.25rem;
                font-weight: 600;
                color: #1a1a1a;
                margin: 0;
                text-align: left;
            }
            .podcast-card-button-wrapper {
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                padding: 1.5rem;
                background: linear-gradient(to top, rgba(255,255,255,1) 50%, rgba(255,255,255,0) 100%);
                transform: translateY(100%);
                transition: transform 0.3s ease-in-out;
            }
            .podcast-card:hover .podcast-card-button-wrapper {
                transform: translateY(0);
            }
            .podcast-card-button {
                display: block;
                width: 100%;
                padding: 0.75rem 1rem;
                background-color: #1877f2; /* Using --primary-blue from your styles.css */
                color: #fff;
                border: none;
                border-radius: 8px;
                font-size: 1rem;
                font-weight: 600;
                text-align: center;
                cursor: pointer;
                transition: background-color 0.2s;
            }
            .podcast-card-button:hover {
                background-color: #166bda;
            }

            /* Responsive adjustments */
            @media (max-width: 1024px) {
                .podcast-grid {
                    grid-template-columns: repeat(2, 1fr);
                }
            }
            @media (max-width: 768px) {
                .podcast-grid {
                    grid-template-columns: 1fr;
                }
                .podcast-container h1 {
                    font-size: 2rem;
                }
            }
        `;

        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = css;
        document.head.appendChild(style);
    }

    render() {
        const podcasts = podcastData;
        const gridHTML = podcasts.map(podcast => this.createPodcastCard(podcast)).join('');

        this.element.innerHTML = `
            <div class="podcast-container">
                   <h3>The</h3>
                <h1>footballgirl podcast</h1>
                <div class="podcast-grid">
                    ${gridHTML}
                </div>
            </div>
        `;
    }

    createPodcastCard(podcast) {
        return `
            <div class="podcast-card" data-podcast-id="${podcast.id}">
                <img src="${podcast.image}" alt="${podcast.title}" class="podcast-card-image">
                <div class="podcast-card-content">
                    <h3 class="podcast-card-title">${podcast.title}</h3>
                </div>
                <div class="podcast-card-button-wrapper">
                    <button class="podcast-card-button">More</button>
                </div>
            </div>
        `;
    }

    attachEventListeners() {
        this.element.addEventListener('click', (e) => {
            const button = e.target.closest('.podcast-card-button');
            if (button) {
                const card = button.closest('.podcast-card');
                const podcastId = card.dataset.podcastId;
                if (podcastId && this.onPodcastClick) {
                    this.onPodcastClick(podcastId);
                }
            }
        });
    }
}